import { ORM } from "redux-orm"

const orm = new ORM()

export default orm
